import React from "react"

import * as styles from "./index.module.scss"

interface Props {
  content: React.ReactNode
  children: React.ReactNode
  containerClassName?: string
  contentClassName?: string
  buttonClassName?: string
  mainButtonTabIndex?: number
  emptyFocusButtonClassName?: string
  "data-testid"?: string
}

/**
 * Provides a button that controls hiding/showing content based on focus, useful for allowing interactivity without JS.
 * @param content The content to show/hide when the button is focused/unfocused.
 * @param children The button to focus/unfocus.
 */
function ButtonFocusToggle({
  children,
  content,
  containerClassName,
  contentClassName,
  buttonClassName,
  emptyFocusButtonClassName,
  mainButtonTabIndex = 0,
  "data-testid": dataTestId,
}: Props) {
  return (
    <div
      className={`${styles.buttonContainer} ${containerClassName}`}
      data-testid={dataTestId}
    >
      <div
        role="button"
        className={`${styles.emptyFocusButton} ${emptyFocusButtonClassName}`}
        tabIndex={-1}
        data-testid={`${dataTestId}-empty-focus-button`}
      />
      <div
        role="button"
        className={`${styles.mainButton} ${buttonClassName}`}
        tabIndex={mainButtonTabIndex}
      >
        {children}
        <div className={`${styles.content} ${contentClassName}`}>{content}</div>
      </div>
    </div>
  )
}

export default ButtonFocusToggle
